<template>
  <ticket-device-info-base-component
    :ticket-details="ticketDetails"
    :hide-link="hideLink"
    @device-link-click="onDeviceLinkClick"
  />
</template>

<script setup lang="ts" generic="T extends TicketDetails">
import { computed } from "vue";
import { useRouter } from "vue-router";
import type { TicketDetails } from "@/_store/tickets/tickets.module";
import { isMspAccessRestricted } from "@/_helpers/msp-permissions.ts";
import { RouteName } from "@/constants/routes";
import { useWorkspaceStore } from "@/_store/workspace.module.ts";
import { AppContext } from "@/types";
import TicketDeviceInfoBaseComponent from "@/components/tickets/ticket-preview-details/base-components/TicketDeviceInfoBaseComponent.vue";
import { isAccessRestricted } from "@/_helpers/permissions.ts";
import { RolePermissionsScope } from "@/constants/roles.ts";

const props = withDefaults(
  defineProps<{
    ticketDetails: T;
    context: AppContext;
    isSoc?: boolean;
  }>(),
  {
    isSoc: false,
  }
);

const router = useRouter();
const workspaceStore = useWorkspaceStore();
const isMspContext = computed(() => props.context === AppContext.MSP);

const hideLink = computed(() => {
  return isMspContext.value
    ? isMspAccessRestricted(RolePermissionsScope.VIEWS, "devicesView")
    : isAccessRestricted(RolePermissionsScope.VIEWS, "devicesView");
});

const onDeviceLinkClick = async () => {
  const enrollmentCode = props.ticketDetails?.sections?.deviceMetaData?.enrollmentCode;

  if (isMspContext.value) {
    await router.push({
      name: RouteName.MSP_DEVICES_TAB,
      query: {
        search: enrollmentCode,
      },
    });
    return;
  }

  if (props.isSoc && props.ticketDetails.workspaceId) {
    await workspaceStore.updateWorkspaceAndPermissions(props.ticketDetails.workspaceId, false);
  }

  await router.push({
    name: RouteName.DEVICES,
    query: {
      search: enrollmentCode,
    },
  });
};
</script>
